// Hardcoded SKUs for cross-sell products
export const crossSellSkus = [
  '106002846',
  '106003176',
  '106003185',
  '106003188',
  '106003192',
  '106003201',
  '106003354',
  '106003476',
  '106003521',
  '106003522',
  '106003523',
  '106032243',
  '106032244',
  '106032246',
  '106032267',
  '106032284',
  '106032290',
  '106032292',
  '106032313',
  '106032333',
  '106032334',
  '106032335',
  '106032336',
  '106032339',
  '106032340',
  '106032341',
  '106032342',
  '106032343',
  '106032345',
  '106032347',
  '106032350',
  '106032352',
  '106032353',
  '106032354',
  '106032370',
  '106040040',
  '106046761',
  '106046762',
  '106046766',
  '106046773',
  '106046786',
  '106046793',
  '109001748',
  '109001751',
  '109001752',
  '109003067',
  '109003098',
  '109003113',
  '109003116',
  '109003119',
  '109003121',
  '109003130',
  '109003141',
  '109003247',
  '109003248',
  '109003347',
  '109003348',
  '109003351',
  '109003356',
  '109003365',
  '109003366',
  '109003367',
  '109003372',
  '109003373',
  '109003374',
  '109003375',
  '109003378',
  '109003379',
  '109003381',
  '109003383',
  '109003384',
  '109003385',
  '109003388',
  '109003422',
  '109009602',
  '109009625',
  '109009650',
  '109010317',
  '109010323',
  '109010329',
  '109010333',
  '109010334',
  '109010335',
  '109010398',
  '109010410',
  '109010411',
  '109010414',
  '109010416',
  '109010421',
  '109010422',
  '109010423',
  '109010433',
  '109010534',
  '109015487',
  '109015491',
  '109015494',
  '109015496',
  '109015497',
  '109015499',
  '109015501',
  '109015503',
  '109015504',
  '109015505',
  '109015506',
  '109015507',
  '109015509',
  '109015510',
  '109015512',
  '109015513',
  '109015515',
  '109015519',
  '110006748',
  '110006775',
  '110006777',
  '110006798',
  '110006800',
  '110006802',
  '110006803',
  '110006821',
  '110006823',
  '110006824',
  '110006825',
  '110006826',
  '110006827',
  '110006828',
  '110006829',
  '110006830',
  '110006839',
  '110006840',
  '110006842',
  '110006845',
  '110006850',
  '110006872',
  '110006874',
  '110006876',
  '110006889',
  '110006890',
  '110006892',
  '110007913',
  '111001070',
  '111001081',
  '111001151',
  '111001174',
  '111001175',
  '111001176',
  '111001188',
  '111001189',
  '111001209',
  '111001214',
  '111001218',
  '111001220',
  '111001224',
  '111001229',
  '111001231',
  '111001233',
  '111001766',
  '111001767',
  '111300917',
  '111301197',
  '117000041',
  '117000087',
  '117000088',
  '117000125',
  '117000144',
  '117000145',
  '117000147',
  '117000151',
  '117000152',
  '117000153',
  '117000154',
  '117000155',
  '117000156',
  '117000157',
  '117000159',
  '117000160',
  '117000169',
  '117000171',
  '117000173',
  '117000174',
  '117000192',
  '117000193',
  '117000194',
  '117000195',
  '117000196',
  '117000197',
  '117000198',
  '117000199',
  '117000200',
  '117000201',
  '117000202',
  '117000239',
  '117000241',
  '117000243',
  '117000245',
  '117000248',
  '117000250',
  '117000251',
  '117000253',
  '117000255',
  '117000261',
  '117001401',
  '117001405',
  '117001408',
  '117001409',
  '118000004',
  '118000026',
  '118000028',
  '119002662',
  '119002664',
  '119002665',
  '119002667',
  '119002677',
  '119002680',
  '119002685',
  '119002687',
  '119002688',
  '119002691',
  '119002692',
  '119002693',
  '119002697',
  '120000517',
  '120000520',
  '120000524'
];

export interface CrossSellItemProps {
  sku: string;
  link_type: string;
  linked_product_sku: string;
  linked_product_type: string;
  position: number;
}

export const MAX_CROSS_SELL_DISPLAY_ITEMS = 4;

export const FEATURE_FLAG_CROSS_SELL = 'cross-sell';

export const FEATURE_FLAG_CROSS_SELL_DYNAMIC = 'cross-sell_dynamic';

export const FEATURE_FLAG_CROSS_SELL_TOP = 'cross-sell-top';

export const FEATURE_FLAG_CROSS_SELL_VERTICAL = 'cross-sell-vertical';

export const FEATURE_FLAG_CROSS_SELL_ORDER_DETAIL = 'cross-sell_order-detail';

export const CROSS_SELL_VERTICAL_BREAKPOINT = 1366;

export type CrossSellContext = 'orders' | 'details' | 'checkout';
